import { render, staticRenderFns } from "./PreviewSubpage.vue?vue&type=template&id=23a6226c&"
import script from "./PreviewSubpage.vue?vue&type=script&lang=js&"
export * from "./PreviewSubpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports